module.exports = __webpack_public_path__ + "images/danilo.jpg?v=3fd41df612703206ba242f9581b9e881";